import { Flex, Tag } from 'antd';
import React from 'react';

import './TabsGroup.scss';

export default function TabsGroup({ items }) {
  return (
    <>
      <Flex className='tabs-group flex-1'>
        {items.map((item, index) => (
          <Flex key={`tab-item-${index}`} gap={8} align='center' justify='center' className={`tab-item${item.active ? ' active' : ''}`} onClick={item.onClick}>
            <p className='body1'>{item.label}</p>
            {item.count && (
              <Tag className={`round${item.light ? ' light' : ''}`} color={item.count.color}>
                {item.count.value}
              </Tag>
            )}
          </Flex>
        ))}
      </Flex>
    </>
  );
}
